/**
 * Variables d'environnement pour le configurateur Suzuki
 * 
 * Ces variables sont injectées par Vite au moment du build
 * en fonction du mode sélectionné (--mode preprod ou --mode production)
 */

// Récupération de l'URL de précommande depuis les variables d'environnement Vite
export const PREORDER_URL = import.meta.env.VITE_PREORDER_URL || 'https://www.suzuki.fr';

// Environnement actuel (production, preprod, development)
export const APP_ENV = import.meta.env.VITE_APP_ENV || 'production';

// Log de la configuration (uniquement en développement)
if (import.meta.env.DEV) {
    console.log(`[CONFIG] Deploy environment: ${APP_ENV}`);
    console.log(`[CONFIG] Using preorder URL: ${PREORDER_URL}`);
}